import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PlusIcon } from "icons/plus-in-circle.svg";
import PropTypes from "prop-types";
import { addNewTerm } from "slices/settings/slices/acronymIgnoreSlice";
import { selectAcronymIgnore } from "slices/settings/selectors";

const SubHeader = ({ selectedRowIndex }) => {
  const dispatch = useDispatch();
  const { updatedBy, lastUpdated, editMode } = useSelector(selectAcronymIgnore);

  return (
    <div
      className="acronym_ignore_list__subheader"
      data-testid="acronym_ignore_list__subheader"
    >
      {updatedBy && lastUpdated ? (
        <p>
          Last updated by {updatedBy} on {lastUpdated}
        </p>
      ) : (
        <p>Last update by System</p>
      )}
      <div>
        <p>
          This is a list of words (case sensitive, normally UPPERCASE) that we
          will ignore when searching for possible acronyms. Use &apos;*&apos; to
          match any text e.g. DARPA-BAA*
        </p>
        {editMode && (
          <button
            type="button"
            onClick={() => {
              dispatch(addNewTerm(selectedRowIndex));
            }}
          >
            <span>
              <PlusIcon />
            </span>
            <span>New Term</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SubHeader;

SubHeader.propTypes = {
  selectedRowIndex: PropTypes.number.isRequired,
};
